import React, { Component } from 'react'
import { connect } from "react-redux"

import { toggle } from "../../modules/actions"

import './buttons.scss'

class GridButton extends Component {

    render() {
            return (
                <button
                    className={
                        this.props.grid ? "button active" : "button"
                        + " grid-button"
                    }
                    onClick={() => {
                        this.props.toggle("grid")
                    }}>
                    Grid
                </button> 
            )

    }

}


const mapStateToProps = (state) => {
    return {
      playing: state.playing,
      grid: state.grid,
    }
  }
  
  export default connect(
      mapStateToProps,
      { toggle }
      )(GridButton);